import type { LanguageProduct } from "../types/PersologOnlineTypes";

/**
 * Reduces a list of LanguageProduct entries into a map of product name → language codes.
 */
export function extractLanguages(productLanguages: LanguageProduct[]): { [key: string]: string[] } {
    return productLanguages.reduce<{ [key: string]: string[] }>((acc, languageProduct) => {
        acc[languageProduct.name] = languageProduct.languages.map((lang: string) => lang);
        return acc;
    }, {});
}

/**
 * The language to generate a product in when the trainer has not picked one from the list: the
 * preferred (project) language if the product is active in it, otherwise English, German or the first
 * active language. A project language the product lacks would fail in InDesign (RDT-532), so it is
 * only used when no active languages are known at all.
 */
export function pickGenerationLanguage(available: string[], preferred: string): string {
    if (available.includes(preferred)) return preferred;
    return ["en", "de"].find((language) => available.includes(language)) ?? available[0] ?? preferred;
}
